import { Copy } from "lucide-react";
import { toast } from "sonner";

export function CopyVin({ vin, testid, className = "" }) {
  if (!vin) return null;
  const copy = async (e) => {
    e.stopPropagation();
    try { await navigator.clipboard.writeText(vin); }
    catch {
      const t = document.createElement("textarea"); t.value = vin; document.body.appendChild(t); t.select();
      try { document.execCommand("copy"); } finally { document.body.removeChild(t); }
    }
    toast.success("VIN skopírované");
  };
  return (
    <span role="button" tabIndex={0} onClick={copy} onKeyDown={(e) => { if (e.key === "Enter") { copy(e); } }} title="Kopírovať VIN"
      className={`inline-flex max-w-full cursor-pointer items-center gap-1 rounded px-1 font-mono transition-colors hover:bg-primary/10 hover:text-primary ${className}`} data-testid={testid}>
      <span className="truncate">{vin}</span><Copy className="h-3 w-3 shrink-0 opacity-70" />
    </span>
  );
}
